export const ENV = () => {
    return {
        BASE_URL: 'https://gateway.bitazzax.com/api',
        ICON_URL: 'https://assets.bitazzax.com/icons',
        WEB_TRADE: 'https://trade.bitazza.com',
    }
}
